// Real-Time Searches deep link — same convention the app already uses
// from Reports/Alerts and History (see RealTimeHistory/@hooks/useFilters.js).
// Shared by Activity and the searches of a pass (CU-869fmm943).
export function realTimeSearchHref(searchId) {
	return `/real-time/searches?idSearch=${encodeURIComponent(searchId)}`
}
